/**
 * 本地存储工具（兼容 SSR）
 */
export const setLocalStore = (key: string, value: any) => {
  if (!key) return
  if (typeof window === 'undefined') return // SSR 阻止执行

  let storeValue: string
  if (typeof value === 'string' || typeof value === 'number') {
    storeValue = value.toString()
  } else {
    try {
      storeValue = JSON.stringify(value)
    } catch (e) {
      console.error('localStorage set error: ', e)
      return
    }
  }

  try {
    window.localStorage.setItem(key, storeValue)
  } catch (e) {
    console.error('localStorage set error: ', e)
  }
}

export const getLocalStore = <T = any>(key: string): T | null => {
  if (!key) return null
  if (typeof window === 'undefined') return null // SSR 阻止执行

  const value = window.localStorage.getItem(key)
  if (!value) return null

  try {
    return JSON.parse(value) as T
  } catch {
    // 如果不是 JSON 格式，直接返回字符串
    return value as unknown as T
  }
}

export const removeLocalStore = (key: string) => {
  if (!key) return
  if (typeof window === 'undefined') return // SSR 阻止执行
  try {
    window.localStorage.removeItem(key)
  } catch (e) {
    console.error('localStorage remove error: ', e)
  }
}

/**
 * 清空 localStorage
 */
export const clearLocalStore = () => {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.clear()
  } catch (e) {
    console.error('localStorage clear error: ', e)
  }
}
